module.exports = __webpack_public_path__ + "media/slick/ajax-loader-fb6f3c23.gif";